import React, { useState } from "react";
import { Box, Flex, Label } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import CriticalInfoModal from "./criticalInfoModal";
import CheckboxField from "components/FormFields/CheckboxField";
import get from "lodash/get";

const CriticalInfoSummary = ({ data = {}, themeColors }) => {
  const consents = get(data, "consents", []);
  const disableModal = get(data, "disableModal", false);
  const [modalData, setModalData] = useState({ isOpen: false });

  const openModal = data =>
    !disableModal ? setModalData({ isOpen: true, ...data }) : () => {};
  const closeModal = () => setModalData({ isOpen: false });

  return (
    <>
      {consents.map(
        ({
          field,
          label,
          details,
          detailsList, // Use to construct a label where only certain areas of the label are clickable
          mandatory_read_message,
          disabled,
          pdfViewerData = {},
          iframe = false
        }) => (
          <Flex key={field}>
            <Box
              minWidth={"1.2rem"}
              flex={0}
              onClick={() =>
                mandatory_read_message
                  ? openModal({
                      field,
                      label,
                      details,
                      mandatory_read_message,
                      pdfViewerData,
                      iframe
                    })
                  : null
              }
            >
              <Label>
                <CheckboxField
                  id={field}
                  field={field}
                  label=""
                  checkBoxOnly
                  disabled={disabled}
                  themeColors={themeColors}
                />
              </Label>
            </Box>
            <Box
              sx={{
                cursor: "text",
                paddingLeft: "1rem"
              }}
            >
              {detailsList ? (
                detailsList.map(({ label, details, popupLabel }) => (
                  <span
                    key={popupLabel || label}
                    style={{
                      cursor: details && !disableModal ? "pointer" : "text"
                    }}
                    onClick={() => {
                      // only if we have details we would open the modal. Otherwise the label is just rendered without any click actions
                      if (details) {
                        openModal({
                          field,
                          label: popupLabel || label,
                          details,
                          mandatory_read_message,
                          pdfViewerData,
                          iframe
                        });
                      }
                    }}
                  >
                    <FormattedMessage html id={label} />
                  </span>
                ))
              ) : (
                <span
                  style={{ cursor: !disableModal ? "pointer" : "text" }}
                  onClick={() => {
                    openModal({
                      field,
                      label,
                      details,
                      mandatory_read_message,
                      pdfViewerData,
                      iframe
                    });
                  }}
                >
                  <FormattedMessage html id={label} />
                </span>
              )}
            </Box>
          </Flex>
        )
      )}
      {modalData.isOpen && (
        <CriticalInfoModal
          id={modalData.field}
          field={modalData.field}
          isOpen={modalData.isOpen}
          closeModal={closeModal}
          critical_info={modalData.label}
          details={modalData.details}
          mandatory_read_message={modalData.mandatory_read_message}
          themeColors={themeColors}
          iframe={modalData.iframe}
          pdfViewerData={modalData.pdfViewerData}
        />
      )}
    </>
  );
};

export default CriticalInfoSummary;
